import type React from 'react';

type Props = {
  label: string;
  value: number;
  max?: number;
  color?: string;
  icon?: React.ReactNode;
};

export function GaugePill({
  label,
  value,
  max = 10,
  color = 'var(--gauge-mood, #8b5cf6)',
  icon,
}: Props) {
  const clamped = Math.max(0, Math.min(value, max));
  const deg = (clamped / max) * 360;

  return (
    <div className="flex items-center gap-2 rounded-full border border-border/70 px-2 py-1 text-xs text-muted-foreground">
      <div className="relative h-7 w-7">
        <div className="absolute inset-0 rounded-full bg-muted" />
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background: `conic-gradient(${color} ${deg}deg, transparent ${deg}deg)`,
          }}
        />
        <div className="absolute inset-[4px] grid place-items-center rounded-full bg-background text-[10px] font-semibold text-foreground">
          {clamped}
        </div>
      </div>
      <div className="flex items-center gap-1">
        {icon}
        <span>{label}</span>
      </div>
    </div>
  );
}
